import React, { useState, useRef, useEffect } from "react";
import $ from "jquery";
import axios from "axios";
import { myConfig } from "../config";
import Header from "../Pages/Header";
import { SettingsPhone } from "@material-ui/icons";
import Footer from "./Footer";
import lang from "./lang.json";

function WelcomePage(props) {
  const [faqs, setFaqs] = useState([]);
  const [lan, setlan] = useState({});
  const [phone, getphone] = useState("");
  const [otp, getotp] = useState("");
  const [zain, setdubai] = useState(/zain/);
  const [zong, setzong] = useState(/zong/);
  const [virgin, setvirgin] = useState(/virgin/);
  const [voda, setvoda] = useState(/voda/);
  const [beeline, setbeeline] = useState(/beeline/);
  const [tmobile, settmobile] = useState(/tmobile/);
  const [orange, setorange] = useState(/orange/);
  const [play, setplay] = useState(/play/);
  const [plus, setplus] = useState(/plus/);

  useEffect(() => {
    localStorage.setItem("activetab", "welcome");
    var str = localStorage.getItem("lang");
    
    console.log("strstrstr",str);
    console.log("strstrstr",window.location.pathname);
    console.log("strstrstr",zain.test(window.location.pathname));
    if (str == undefined) {
      str = localStorage.setItem("lang", "en");
    }
    // if (zain.test(window.location.pathname) == true) {
    //   if (str == undefined) {
    //     str = localStorage.setItem("lang", "en");
    //   }
    // } else if (zong.test(window.location.pathname) == true) {
    //   if (str == undefined) {
    //     str = localStorage.setItem("lang", "en");
    //   }
    // } else if (virgin.test(window.location.pathname) == true) {
    //   if (str == undefined) {
    //     str = localStorage.setItem("lang", "ven");
    //   }
    // } else if (voda.test(window.location.pathname) == true) {
    //   if (str == undefined) {
    //     str = localStorage.setItem("lang", "voen");
    //   }
    // } else if (beeline.test(window.location.pathname) == true) {
    //   if (str == undefined) {
    //     str = localStorage.setItem("lang", "boar");
    //   }
    // } else if (tmobile.test(window.location.pathname) == true) {
    //   if (str == undefined) {
    //     str = localStorage.setItem("lang", "plten");
    //   }
    // } else if (orange.test(window.location.pathname) == true) {
    //   if (str == undefined) {
    //     str = localStorage.setItem("lang", "ploen");
    //   }
    // } else if (play.test(window.location.pathname) == true) {
    //   if (str == undefined) {
    //     str = localStorage.setItem("lang", "plpen");
    //   }
    // } else if (plus.test(window.location.pathname) == true) {
    //   if (str == undefined) {
    //     str = localStorage.setItem("lang", "plppen");
    //   }
    // } else {
    //   str = localStorage.setItem("lang", "en");
    // }

    if (str == "en") {
      setlan(lang.en);
    } else if (str == "ar") {
      setlan(lang.ar);
    } else if (str == "var") {
      setlan(lang.var);
    } else if (str == "ven") {
      setlan(lang.ven);
    } else if (str == "voen") {
      setlan(lang.voen);
    } else if (str == "boen") {
      setlan(lang.boen);
    } else if (str == "boar") {
      setlan(lang.boar);
    } else if (str == "plten") {
      setlan(lang.plten);
    } else if (str == "ploen") {
      setlan(lang.ploen);
    } else if (str == "plpen") {
      setlan(lang.plpen);
    } else if (str == "plppen") {
      setlan(lang.plppen);
    } else {
      setlan(lang.en);
    }
    console.log(lan);
  });

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios(myConfig.server_url + "listAllFAQ/", {
        headers: { Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64") },
      });
      setFaqs(result.data.listData);

      const results = await axios(myConfig.server_url + "getSubscribedUser/" + window.sessionStorage.getItem("userId"), {
        headers: {
          Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64"),
          "X-Content-Type-Options": "nosniff",
        },
      });

      if (results.status == 200) {
        localStorage.setItem("name", results.data.name);
        localStorage.setItem("prfileImage", results.data.profileImage);
        axios.post(myConfig.billing_url + "updateLogin.php?operator_id=" + 255 + "&msisdn=" + window.sessionStorage.getItem("userId"));
        setTimeout(() => {
          window.sessionStorage.setItem("isLogin", true);
        window.location.href = "/";
        }, 3000);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Header></Header>
      <div className="landingPage">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="heading">{lan.product_name}</div>
              <div className="link">
              <img src="/asset/images/etisalat_promo_banner.png" />
              </div>
              

              <div className="subheading" style={{ marginBottom: "10%" }}>
                <span>{lan.welcomesuccess} </span>
                {lan.callback}
              </div>
              <div className="termsData">
                {" "}
                <a href="/">click here</a> to access the SSN.
              </div>
              <div className="termsData">
                {" "}
                <a href="/">click here</a> for support and help
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}

export default WelcomePage;
